import {Button, Space} from "antd";
import {CopyOutlined} from "@ant-design/icons";
import copyToClipboard from "../../helpers/copyToClipboard";
import React from "react";

export default function PublicUrl({publicKey}) {

    if (publicKey) {
        // const to = `/client-info/${publicKey}`;
        const url = `https://sila-crm.ru/client-info/${publicKey}`;
        return (
            <Space>
                <Button size={'large'} icon={<CopyOutlined/>} onClick={() => copyToClipboard(url)}/>
                <div>
                    <div>Ссылка на страницу</div>
                    <a href={url} target={'_blank'} rel={'noreferrer'}>{url}</a>
                </div>
            </Space>
        )
    } else {
        return null
    }
}
